import React from 'react';
import './home.css';  // Optional: Add custom styles for the section and boxes
import { useEffect } from 'react';
import { motion } from 'framer-motion';


	
  
  const Services = () => {
	useEffect(() => {
		const serviceBoxes = document.querySelectorAll('.service-box');
		serviceBoxes.forEach((box, index) => {
		  box.style.animationDelay = `${index * 0.2}s`; // Add staggered animation delay
		});
	  }, []);
	return (
	  <section className="services-section"   id='service'>
		<h1 className="heading-service">Peru-Tech – Driving Efficiency and Innovation Through Expert Conveyor Solutions</h1>
		
		<h2 className="services-title">Our Services</h2>
		<div className="services-container">
		  <motion.div
			className="service-box"
			initial={{ opacity: 0, y: 50 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.6, delay: 0.2 }}
		  >
			<i className="fas fa-industry service-icon"></i>
			<h3>Custom Conveyor Manufacturing</h3>
<p>We design and manufacture conveyor systems tailored to your production requirements, ensuring maximum efficiency and reliability.</p>
		  </motion.div>
  
		  <motion.div
			className="service-box"
			initial={{ opacity: 0, y: 50 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.6, delay: 0.4 }}
		  >
			<i className="fas fa-shield-alt service-icon"></i>
			<h3>Uncompromising Quality</h3>
			<p>Our solutions are built to last, ensuring maximum durability and reliability.</p>
		  </motion.div>
  
		  <motion.div
			className="service-box"
			initial={{ opacity: 0, y: 50 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.6, delay: 0.6 }}
		  >
			<i className="fas fa-tachometer-alt service-icon"></i>
			<h3>Unmatched Performance</h3>
			<p>Our systems are optimized for peak performance and efficiency in all conditions.</p>
		  </motion.div>
		  <motion.div
			className="service-box"
			initial={{ opacity: 0, y: 50 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.6, delay: 0.6 }}
		  >
			<i className="fas fas fa-user-alt service-icon"></i>
			<h3>Our Services</h3>
			<p>we offer a comprehensive range of conveyor solutions, including expert installation, maintenance, and optimization. With tailored services for every industry, we ensure your systems operate at peak performance and efficiency</p>
		  </motion.div>
		</div>
	  </section>
	);
  };

export default Services;
